import { useSelector } from 'react-redux';
import { userRoleSelector } from '../store/selectors';
import { QueryKeys, useCustomQuery } from './index';
import Config from '../../config';
import userRoles from '../authorization/userRoles';
import { Client } from '../../administration/clientPage/types';

export const useUserHelpClients = () => {
  const role = useSelector(userRoleSelector);

  return useCustomQuery<Client[]>(
    [QueryKeys.helpPage.UserHelpClients],
    {
      url: Config.endpoints.FETCH_CLIENT_LIST,
      initialData: [],
      enabled: role === userRoles.SUPER_USER,
    }
  );
};
